import {
  Component,
  Input,
  OnChanges
} from '@angular/core';

import { JobStatusBookingPipe } from '../transaction-center/jobs/transaction-center.jobs.status-booking.pipe';

import {
  statusCodeFor,
  statusToneClass
} from '../transaction-center/jobs/transaction-center.jobs.status-tone';

// A booking's status as a coloured dot before its name, the wording in the tooltip
@Component({
  selector   : 'wor-booking-diary-status-dot',
  template: require('./booking-diary.status-dot.component.html')
})
export class BookingDiaryStatusDotComponent implements OnChanges {
  @Input() status : string;

  label : string = '';
  tone  : string = '';

  constructor (
    private jobStatusBookingPipe : JobStatusBookingPipe
  ) {}

  ngOnChanges () : void {
    this.label = this.jobStatusBookingPipe.transform(statusCodeFor(this.status));
    this.tone  = statusToneClass(this.status);
  }
}
